// Instead of changing ext z-index, first try to use services/styleFixer.ts and decrease z-index of the parent page node
export const mainZIndex = 10005
